<template>
<v-main>
<h2>Payment Settings</h2>
<div>
<v-btn color="#e00000" outlined style="float:right" @click="addbank=true">Add Bank</v-btn>
</div>
<br><br>
<div style="float:left" v-for="(bank,i) in bank" :key="i">
<v-card style="border-radius:16px;float:left;margin-right:10px" width="300px" height="130px" color="#e00000" class="pt-8 white--text pa-6 mb-4">
<h2 style="font-size:19px">{{bank.accountName}}</h2>
<p><span style="font-size:12px">{{bank.accountNumber}}</span><span style="float:right;font-size:12px">{{bank.bankname}}</span> </p>

</v-card>
</div>
<v-dialog v-model="addbank" width="400px" height="400px">
<AddBank @close="addbank = !addbank"/>
</v-dialog>
</v-main>



</template>




<script>
import AddBank from '@/components/AddBank'


export default{
   data(){
       return{
           bankDetails:{},
           addbank:false
       }
   },
   components:{
       AddBank
   },
   props:{
       bank:{
           type:Array
       }
   }
}

</script>